import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import Sort from "../../lib/appfuse-react/core/Sort";

const name = 'certificateDownload';

const initialState = {
    data: {},
    selection: null,
    pageNumber: 0,
    pageSize: 10,
    sort: null,
    certificatePhoto: null
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = json.toJSON(action.payload);
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setSort(state, action) {
            state.sort = json.toJSON(action.payload);
        },
        setCertificatePhoto(state, action) {
            state.certificatePhoto = json.toJSON(action.payload);
        }
    }
});

export const { setData, setSelection, setPageNumber, setPageSize, setSort, setCertificatePhoto } = slice.actions;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => json.fromJSON(state[name].selection);
export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectSort = state => json.fromJSON(state[name].sort, Sort);
export const selectCertificatePhoto = state => json.fromJSON(state[name].certificatePhoto);

const certificateDownloadReducer = slice.reducer;
export default certificateDownloadReducer;